import script from "./TemplateC.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateC.vue?vue&type=script&setup=true&lang=js"

import "./TemplateC.vue?vue&type=style&index=0&id=583e4cf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583e4cf8"]])

export default __exports__